
import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import NavMeetingsMixin from '@/core/mixins/nav-meetings.mixin';
import NavMixin from '@/core/mixins/nav.mixin';
import { PRIVATE_ROUTES } from '@/app/private/private.routes';

@Component({
  name: 'ed-nav-meetings-mobile'
})
export default class EdNavMeetingsMobile extends Mixins(NavMeetingsMixin, NavMixin) {

  public navMenuID: string = 'EdNavMeetingsMobile';

  get isWebView() {
    return this.$store.state.AppStore.webview;
  }

  get buttonClass() {
    return {
      'ed-header-in-session-menu-item': !this.isWebView,
      'h-100': this.isWebView,
    }
  }

  get navMeetingsMenuMobile(): any[] {
    return this.navMeeting.map(element => {
      return { 
        ...element,
        label: this.$i18n.t(`menu.${element.name}`).toString(),
        params: { 
          id: element.id.toString(),
          classId: this.currentMeetingData.classId.toString()
        },
        pathName: PRIVATE_ROUTES.JOIN_MEETING.NAME,
        meetingId: element.id,
        callback: ({meetingId}) => this.joinMeetingMenu(meetingId)
      }
    });
  }
}
